import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { styledListWrapper, styledListItem } from '@mlb/react-patterns/components/TypeAhead/typeAhead.style';

import TypeaheadBase from '../../TypeaheadBase';

export const Typeahead = styled(TypeaheadBase)`
  padding-bottom: 10px;
  ${styledListWrapper} {
    position: static;
    padding: 5px 0px 0px 0px;
    background-color: ${COLORS.transparent};
    ${styledListItem} {
      background-color: ${COLORS.transparent};
      &:hover {
        background-color: ${COLORS.mlbGrey6};
      }
      &.active {
        background-color: ${COLORS.mlbGrey7};
      }
    }
  }
`;
